import React from "react";
import { useDispatch } from "react-redux";
import ProgramBudgetTable from "../../components/controls/tables/ProgramBudgetTable";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";

const ProgramBudget = ({ programID, defaultProgram, overviewType }) => {
  const dispatch = useDispatch();
  return (
    <div className="h-full">
      <ColumnConfigProvider tableName="ProgramBudget">
        <ProgramBudgetTable
          programID={programID}
          dispatch={dispatch}
          tableName="ProgramBudget"
        />
      </ColumnConfigProvider>
    </div>
  );
};

export default ProgramBudget;
